<template>
  <div>
    <dynamic-template
        :template="html"
        :components="{ Slider, GamesList, ProvablyFair, BonusCards, Raffles }"
    />
  </div>
</template>
<script>
import axios from 'axios'
import DynamicTemplate from '~/components/DynamicTemplate'
import Slider from '~/components/Home/Slider'
import GamesList from '~/components/Home/GamesList'
import ProvablyFair from '~/components/Home/ProvablyFair'
import BonusCards from '~/components/Home/BonusCards'
import Raffles from '~/components/Home/Raffles'

export default {
  components: {DynamicTemplate},

  metaInfo() {
    return {
      title: this.$t('Fair online casino games')
    }
  },

  data() {
    return {
      GamesList,
      ProvablyFair,
      BonusCards,
      Raffles,
      Slider,
      html: ''
    }
  },

  async created() {
    const {data: {html}} = await axios.get('/api/pages/home')
    this.html = `<div>${html}</div>`
  }
}
</script>
